import { Dispatch } from 'react';
import { InsuranceJourneyInsuranceProductsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const YourQuotePagePageEventHandlers = (
  insuranceProducts: InsuranceJourneyInsuranceProductsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onVoluntaryExcessChange: (value: string) => {
      dispatch({
        type: 'set-your-quote-details',
        insuranceProducts: { ...insuranceProducts, voluntaryExcess: value }
      });
    },

    onShowNCDPrice: (value: boolean) => {
      dispatch({
        type: 'set-your-quote-details',
        insuranceProducts: { ...insuranceProducts, showNCDPrice: value }
      });
    }
  };
};
